<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
		<b-card>
			<b-row>
				<b-col cols="12">
					<app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
				</b-col>
			</b-row>
			<b-row v-if="isUploadSuccess">
				<b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							<b-tab title="Approval Instance" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="approvalInstancePageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approvalInstances" :fields="fieldsApprovalInstance" :busy="isDataLoading" :sort-by.sync="sortByApprovalInstance" :sort-desc.sync="sortDescApprovalInstance" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowApprovalInstanceFilter = !isShowApprovalInstanceFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowApprovalInstanceFilter">
										<b-th></b-th>
										<b-th stacked-heading="Approval Tag">
											<b-form-input id="input-approval-tag-table" v-model="filterApprovalInstance.approvalTag" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approval Configuration">
											<v-select append-to-body label="name" :options="approvalConfigurations" :value="filterApprovalInstance.approvalConfigurationId"  :reduce="item => item.id" v-model="filterApprovalInstance.approvalConfigurationId" @search="getApprovalConfigurations" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Configuration Instance">
											<v-select append-to-body label="name" :options="approvalConfigurationInstances" :value="filterApprovalInstance.approvalConfigurationInstanceId"  :reduce="item => item.id" v-model="filterApprovalInstance.approvalConfigurationInstanceId" @search="getApprovalConfigurationInstances" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Type">
											<v-select append-to-body label="name" :options="approvalTypes" :value="filterApprovalInstance.approvalTypeId"  :reduce="item => item.id" v-model="filterApprovalInstance.approvalTypeId" @search="getApprovalTypes" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Current Approver Sequence">
											<b-form-input id="input-current-approver-sequence-table" v-model="filterApprovalInstance.currentApproverSequence" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approval State">
											<v-select append-to-body label="name" :options="approvalStates" :value="filterApprovalInstance.approvalStateId"  :reduce="item => item.id" v-model="filterApprovalInstance.approvalStateId" @search="getApprovalStates" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Document Id">
											<b-form-input id="input-document-id-table" v-model="filterApprovalInstance.documentId" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Status">
											<b-form-input id="input-status-table" v-model="filterApprovalInstance.status" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Originator">
											<v-select append-to-body label="firstName" :options="userInfos" :value="filterApprovalInstance.originatorId"  :reduce="item => item.id" v-model="filterApprovalInstance.originatorId" @search="getUserInfos" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Structure">
											<v-select append-to-body label="name" :options="approvalStructures" :value="filterApprovalInstance.approvalStructureId"  :reduce="item => item.id" v-model="filterApprovalInstance.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( approvalInstancePageSize * (currentApprovalInstancePage - 1))) }}
									</template>
									<template v-slot:cell(approvalConfiguration)="row">
										{{ row.item.approvalConfiguration != null ? row.item.approvalConfiguration.name : "" }}
									</template>
									<template v-slot:cell(approvalConfigurationInstance)="row">
										{{ row.item.approvalConfigurationInstance != null ? row.item.approvalConfigurationInstance.name : "" }}
									</template>
									<template v-slot:cell(approvalType)="row">
										{{ row.item.approvalType != null ? row.item.approvalType.name : "" }}
									</template>
									<template v-slot:cell(approvalState)="row">
										{{ row.item.approvalState != null ? row.item.approvalState.name : "" }}
									</template>
									<template v-slot:cell(originator)="row">
										{{ row.item.originator != null ? row.item.originator.firstName : "" }}
									</template>
									<template v-slot:cell(approvalStructure)="row">
										{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentApprovalInstancePage"
									:total-rows="totalApprovalInstanceRow"
									:per-page="approvalInstancePageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
							<b-tab title="Approver State" active>
								<b-row class="mb-2">
									<b-col>
										<span class="float-right">
											<b-form-select v-model="approverStatePageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
										</span>
									</b-col>
								</b-row>
								<b-row>
								<b-col>
								<div class="table-corner">
									<b-table id="my-table" stacked="md" head-variant="head-light" :no-local-sorting="true" :items="approverStates" :fields="fieldsApproverState" :busy="isDataLoading" :sort-by.sync="sortByApproverState" :sort-desc.sync="sortDescApproverState" small responsive>
									<template v-slot:head(actions)>
										<b-button @click="isShowApproverStateFilter = !isShowApproverStateFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
									</template>
									<template #top-row v-if="isShowApproverStateFilter">
										<b-th></b-th>
										<b-th>
										</b-th>
										<b-th stacked-heading="Approver Type">
											<v-select append-to-body label="name" :options="approverTypes" :value="filterApproverState.approverTypeId"  :reduce="item => item.id" v-model="filterApproverState.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Structure">
											<v-select append-to-body label="name" :options="approvalStructures" :value="filterApproverState.approvalStructureId"  :reduce="item => item.id" v-model="filterApproverState.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approver Level">
											<b-form-input id="input-approver-level-table" v-model="filterApproverState.approverLevel" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Approver User">
											<v-select append-to-body label="firstName" :options="userInfos" :value="filterApproverState.approverUserId"  :reduce="item => item.id" v-model="filterApproverState.approverUserId" @search="getUserInfos" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Activity State">
											<v-select append-to-body label="name" :options="activityStates" :value="filterApproverState.activityStateId"  :reduce="item => item.id" v-model="filterApproverState.activityStateId" @search="getActivityStates" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Approval Configuration Detail">
											<v-select append-to-body label="approverType" :options="approvalConfigurationInstanceDetails" :value="filterApproverState.approvalConfigurationInstanceDetailId"  :reduce="item => item.id" v-model="filterApproverState.approvalConfigurationInstanceDetailId" @search="getApprovalConfigurationInstanceDetails" :filterable="true"></v-select>
										</b-th>
										<b-th stacked-heading="Sequence">
											<b-form-input id="input-sequence-table" v-model="filterApproverState.sequence" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Stored Procedure Name">
											<b-form-input id="input-stored-procedure-name-table" v-model="filterApproverState.storedProcedureName" size="sm"></b-form-input>
										</b-th>
										<b-th stacked-heading="Is Send Notification">
											<b-form-checkbox id="input-is-send-notification-table" @change="getApproverStates" class="float-right" v-model="filterApproverState.isSendNotification"></b-form-checkbox>
										</b-th>
										<b-th>
										</b-th>
									</template>
									<template v-slot:table-busys>
										<div class="text-center my-2">
									<b-spinner class="align-middle text-primary"></b-spinner>
										<strong class="ml-2">Loading..</strong>
										</div>
									</template>
									<template v-slot:cell(no)="row">
										{{ ((row.index + 1) + ( approverStatePageSize * (currentApproverStatePage - 1))) }}
									</template>
									<template v-slot:cell(approvalInstance)="row">
										{{ row.item.approvalInstance != null ? row.item.approvalInstance.approvalTag : "" }}
									</template>
									<template v-slot:cell(approverType)="row">
										{{ row.item.approverType != null ? row.item.approverType.name : "" }}
									</template>
									<template v-slot:cell(approvalStructure)="row">
										{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
									</template>
									<template v-slot:cell(approverUser)="row">
										{{ row.item.approverUser != null ? row.item.approverUser.firstName : "" }}
									</template>
									<template v-slot:cell(activityState)="row">
										{{ row.item.activityState != null ? row.item.activityState.name : "" }}
									</template>
									<template v-slot:cell(approvalConfigurationInstanceDetail)="row">
										{{ row.item.approvalConfigurationInstanceDetail != null ? row.item.approvalConfigurationInstanceDetail.approverType : "" }}
									</template>
									</b-table>
									</div>
								</b-col>
								<b-col cols="12">
									<b-pagination
									class="float-right btn-paging"
									v-model="currentApproverStatePage"
									:total-rows="totalApproverStateRow"
									:per-page="approverStatePageSize"
									aria-controls="my-table"
									></b-pagination>
								</b-col>
								</b-row>
							</b-tab>
						</b-tabs>
					</b-card>
				</b-col>
			</b-row>
		</b-card>
		<template #modal-footer="{ ok, cancel }">
			<b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
				Download Log
			</b-button>
			<b-button size="sm" variant="success" class="float-right" @click="ok()">
				{{ okTitle }}
			</b-button>
			<b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
				Cancel
			</b-button>
		</template>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</b-modal>
</template>
<style lang="scss" scoped>
.card {
	border: 1px solid rgba(0, 0, 0, 0.125) !important;
}
::v-deep.th-message {
	color: red;
}
::v-deep.modal-footer {
	display: block;
}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate"; 
import { required, minLength } from "vuelidate/lib/validators"; 
import { saveAs } from 'file-saver';

import ApprovalInstance from '@/models/ApprovalInstance/ApprovalInstance';
import ApprovalInstanceList from '@/models/ApprovalInstance/ApprovalInstanceList';
import ApprovalInstanceFilter from '@/filters/ApprovalInstance/ApprovalInstanceFilter';

import ApprovalConfiguration from '@/models/ApprovalConfiguration/ApprovalConfiguration';
import ApprovalConfigurationFilter from '@/filters/ApprovalConfiguration/ApprovalConfigurationFilter';
import ApprovalConfigurationInstance from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstance';
import ApprovalConfigurationInstanceFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceFilter';
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import ApprovalState from '@/models/ApprovalState/ApprovalState';
import ApprovalStateFilter from '@/filters/ApprovalState/ApprovalStateFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
import ApproverState from '@/models/ApprovalInstance/ApproverState';
import ApproverStateFilter from '@/filters/ApprovalInstance/ApproverStateFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ActivityState from '@/models/ActivityState/ActivityState';
import ActivityStateFilter from '@/filters/ActivityState/ActivityStateFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import AppInputFileupload from '@/components/AppInputFileupload';
import AppInputDatetimepicker from '@/components/AppInputDatetimepicker';
import AppInputDatetimepickerRange from '@/components/AppInputDatetimepickerRange';
export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,AppInputDatetimepicker,AppInputDatetimepickerRange,},
	data() {
		return {
			fileupload: null,
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			perPage: 10,
			currentPage: 1,
			totalData:0,
			fieldsApprovalInstance: [
				{"no" : { "class" : "th-number"}}, 
				{"approvalTag": { "class" : "th-approval-tag", "label" : "Approval Tag"}, key: 'approvalTag', sortable: true}, 
				{"approvalConfiguration": { "class" : "th-approval-configuration", "label" : "Approval Configuration"}, key: 'approvalConfiguration', sortable: true}, 
				{"approvalConfigurationInstance": { "class" : "th-approval-configuration-instance", "label" : "Approval Configuration Instance"}, key: 'approvalConfigurationInstance', sortable: true}, 
				{"approvalType": { "class" : "th-approval-type", "label" : "Approval Type"}, key: 'approvalType', sortable: true}, 
				{"currentApproverSequence": { "class" : "th-current-approver-sequence", "label" : "Current Approver Sequence"}, key: 'currentApproverSequence', sortable: true}, 
				{"approvalState": { "class" : "th-approval-state", "label" : "Approval State"}, key: 'approvalState', sortable: true}, 
				{"documentId": { "class" : "th-document-id", "label" : "Document Id"}, key: 'documentId', sortable: true}, 
				{"status": { "class" : "th-status", "label" : "Status"}, key: 'status', sortable: true}, 
				{"originator": { "class" : "th-originator", "label" : "Originator"}, key: 'originator', sortable: true}, 
				{"approvalStructure": { "class" : "th-approval-structure", "label" : "Approval Structure"}, key: 'approvalStructure', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsApproverState: [
				{"no" : { "class" : "th-number"}}, 
				{"approvalInstance": { "class" : "th-approval-instance", "label" : "ApprovalInstance"}, key: 'approvalInstance', sortable: true}, 
				{"approverType": { "class" : "th-approver-type", "label" : "Approver Type"}, key: 'approverType', sortable: true}, 
				{"approvalStructure": { "class" : "th-approval-structure", "label" : "Approval Structure"}, key: 'approvalStructure', sortable: true}, 
				{"approverLevel": { "class" : "th-approver-level", "label" : "Approver Level"}, key: 'approverLevel', sortable: true}, 
				{"approverUser": { "class" : "th-approver-user", "label" : "Approver User"}, key: 'approverUser', sortable: true}, 
				{"activityState": { "class" : "th-activity-state", "label" : "Activity State"}, key: 'activityState', sortable: true}, 
				{"approvalConfigurationInstanceDetail": { "class" : "th-approval-configuration-instance-detail", "label" : "Approval Configuration Detail"}, key: 'approvalConfigurationInstanceDetail', sortable: true}, 
				{"sequence": { "class" : "th-sequence", "label" : "Sequence"}, key: 'sequence', sortable: true}, 
				{"storedProcedureName": { "class" : "th-stored-procedure-name", "label" : "Stored Procedure Name"}, key: 'storedProcedureName', sortable: true}, 
				{"isSendNotification": { "class" : "th-is-send-notification", "label" : "Is Send Notification"}, key: 'isSendNotification', sortable: true}, 
				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: true},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessage', sortable: true},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			busy:false,
			isDataLoading: false,
			isBusy : false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			approvalInstances : [],
			approvalInstanceId : '',
			totalApprovalInstanceRow : 0,
			isShowApprovalInstanceFilter: false,
			filterApprovalInstance : null,
			currentApprovalInstancePage : 1,
			approvalInstancePageSize: 10,
			sortByApprovalInstance: '',
			sortDescApprovalInstance: '',
			filterApproverState : null,
			currentApproverStatePage : 1,
			approverStatePageSize: 10,
			sortByApproverState: '',
			sortDescApproverState: '',
			sortingByApproverState: [],
			approverStates : [],
			approverStateId : '',
			totalApproverStateRow : 0,
			isShowApproverStateFilter: false,
			approvalInstances: [],
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			activityStates: [],
			approvalConfigurationInstanceDetails: [],
			approvalConfigurations: [],
			approvalConfigurationInstances: [],
			approvalTypes: [],
			approvalStates: [],
			processId: "",
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'approvalinstance/confirmUpload',
					[],
					).then(async function(response){
						if (response != null) {
						if (response.data != null) {
							_this.resetModal();
							_this.datas = Array();
							_this.fileupload = null;
							_this.isUploadSuccess = false;
						}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
				let data = new FormData();
				data.append('file', this.fileupload);
				let _this = this;
				this.$http.post(process.env.VUE_APP_API_URL + 'approvalinstance/upload',
					data,
					{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.isBusy = false;
						_this.isUploadSuccess = true;
						_this.getApprovalInstances();
						_this.getApproverStates();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getApprovalInstances : async function() {
			let filter = {};
			Object.assign(filter, this.filterApprovalInstance);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByApprovalInstance = Array();
			if (this.sortByApprovalInstance != null) {
				this.sortingByApprovalInstance[this.sortByApprovalInstance] = this.sortDescApprovalInstance;
			}
			let currentPage = (this.currentApprovalInstancePage - 1);
			ApprovalInstance.getList(this, filter, this.sortingByApprovalInstance, currentPage , this.approvalInstancePageSize).then(result => {
				this.approvalInstances = result.data;
				this.totalApprovalInstanceRow = result.dataCount;
			}).catch(error => {});
		},
		getApproverStates : async function() {
			let filter = {};
			Object.assign(filter, this.filterApproverState);
			filter.draftFromUpload = "1";
			filter.draftMode = "1";
			this.sortingByApproverState = Array();
			if (this.sortByApproverState != null) {
				this.sortingByApproverState[this.sortByApproverState] = this.sortDescApproverState;
			}
			let currentPage = (this.currentApproverStatePage - 1);
			ApproverState.getList(this, filter, this.sortingByApproverState, currentPage , this.approverStatePageSize).then(result => {
				this.approverStates = result.data;
				this.totalApproverStateRow = result.dataCount;
			}).catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getActivityStates : async function(input) {
			let filter = new ActivityStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ActivityState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.activityStates = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstanceDetails : async function(input) {
			let filter = new ApprovalConfigurationInstanceDetailFilter();
			if (input != undefined) {
				filter.approverType = input;
			}
			ApprovalConfigurationInstanceDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstanceDetails = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurations : async function(input) {
			let filter = new ApprovalConfigurationFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalConfiguration.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurations = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalConfigurationInstances : async function(input) {
			let filter = new ApprovalConfigurationInstanceFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalConfigurationInstance.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstances = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStates : async function(input) {
			let filter = new ApprovalStateFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalState.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStates = result.data
				}
			})
			.catch(error => {});
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApproverStateFilter = true;
			}
		},
		downloadLog() {
			let _this = this;
			this.$http.post(process.env.VUE_APP_API_URL + 'approvalinstance/downloadlog', [],
			{ headers: { 'Content-Type': 'application/json' }}
			).then(async function(response){
				await saveAs(process.env.VUE_APP_API_URL + 'approvalinstance/downloadlog', "ApprovalInstance.xslx");
				_this.isBusy = false;
			})
			.catch(error => {
				_this.$store.dispatch('addErrorMessageGlobal', error);
				_this.isBusy = false;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		sortByApprovalInstance : {
			handler: function() {
				this.getApprovalInstances();
			}
		},
		sortDescApprovalInstance: {
			handler: function() {
				this.getApprovalInstances();
			}
		},
		currentApprovalInstancePage: {
			handler: function() {
				this.getApprovalInstances();
			}
		},
		approvalInstancePageSize : {
			handler: function() {
				this.getApprovalInstances();
			}
		},
		filterApprovalInstance: {
			handler: function() {
				this.getApprovalInstances();
			},
			deep: true,
		},
		sortByApproverState : {
			handler: function() {
				this.getApproverStates();
			}
		},
		sortDescApproverState: {
			handler: function() {
				this.getApproverStates();
			}
		},
		currentApproverStatePage: {
			handler: function() {
				this.getApproverStates();
			}
		},
		approverStatePageSize : {
			handler: function() {
				this.getApproverStates();
			}
		},
		filterApproverState: {
			handler: function() {
				this.getApproverStates();
			},
			deep: true,
		},
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Proses";
				}
				return "Simpan";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterApprovalInstance = new ApprovalInstanceFilter();
					this.filterApproverState = new ApproverStateFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
